var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('p',[_vm._v("Importing data from Imgur")]),_c('span',{staticClass:"loading-indicator"})])}]

export { render, staticRenderFns }